import { apiFetch } from "../lib/api";

export interface ChannelCheck {
  channel: "rest_auth" | "order_api" | "market_feed" | string;
  ok: boolean;
  message: string;
  latency_ms: number | null;
}

export interface ConnectivityReport {
  connection_id: string;
  broker: string;
  label: string;
  checked_at: string;
  ok: boolean;
  channels: ChannelCheck[];
}

/** Latest cached per-channel connectivity for the user's active connections. */
export async function getConnectivity(): Promise<ConnectivityReport[]> {
  return apiFetch<ConnectivityReport[]>("/connectivity");
}

/** Force a fresh check now (e.g. after refreshing a token). */
export async function runConnectivityCheck(): Promise<ConnectivityReport[]> {
  return apiFetch<ConnectivityReport[]>("/connectivity/check", { method: "POST" });
}

const CHANNEL_LABELS: Record<string, string> = {
  rest_auth: "Login / REST",
  order_api: "Order placement",
  market_feed: "Live price feed",
  instruments_master: "Option chain (today)",
};

export function channelLabel(channel: string): string {
  return CHANNEL_LABELS[channel] ?? channel;
}
